import { Box, Tabs, Tab, Grid } from "@mui/material";
import React, { useState } from "react";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { useForm } from "react-hook-form";
import { OverviewSection } from "./OverViewSection";

const TabsSection: React.FC<any> = React.memo((props) => {
  const { control } = useForm();
  const tabsData: any[] = [
    { label: "OverView", content: <OverviewSection /> },
    { label: "Activities", content: "" },
  ];
  return (
   
     
          <WSTabs id="adasd" justifyTabs="flex-start" control={control} name="tabs" tabs={tabsData} />
 
  );
});

export default TabsSection;
